import axios from 'axios';
import React, { useEffect, useState } from 'react'
import PhoneInput from 'react-phone-input-2';
import Swal from 'sweetalert2';
import ReactGA from 'react-ga';
import { useNavigate } from 'react-router-dom';
import { handleWhatsAppClick } from '../whatsappClickTrack';
function ContactForm({ Heading }) {
    const [userData, setUserData] = useState({ name: '', email: '', phone: '', message: '', category: '' });
    const [errors, setErrors] = useState({});
    const [defaultCountry, setDefaultCountry] = useState('us');
    const [phoneNumber, setPhoneNumber] = useState({ dialingCode: '', number: '' });
    const [isFocused, setIsFocused] = useState(false);
    const navigate = useNavigate()
    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData((prev) => ({
            ...prev, [name]: value
        }))
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        const isFormValid = validateForm();
        if (isFormValid) {
            ReactGA.event({
                category: 'Contact Form',
                action: 'Submit Contact form'
            })
            const body = new FormData();
            body.append('name', userData.name);
            body.append('email', userData.email);
            body.append('subject', 'from product landing page contact form');
            body.append('phone', `${phoneNumber.dialingCode}${phoneNumber.number}`);
            body.append('message', userData.message);
            let url = 'https://noorisys.com/contact-submit/landing-form.php'
            axios
                .post(url, body)
                .then((result) => {

                    setUserData({ name: '', email: '', phone: '', message: '' });
                    // Swal.fire({ title: 'Thank you', icon: 'success', text: 'Thank you for your interest we will contact you shortly' })
                    navigate('/thankyou')
                    setPhoneNumber({ dialingCode: defaultCountry, number: '' })
                },
                    (error) => {
                        Swal.fire({ title: 'Oops', icon: 'error', text: 'Something wrong happened please try again later' })
                    }
                );

                const body1 = new FormData();
                body1.append('name', userData.name);
                body1.append('email', userData.email);                
                    body1.append('inquiry_source', '20');               
                body1.append('mobile', `+${phoneNumber.dialingCode}${phoneNumber.number}`);
                body1.append('message', userData.message);
                let url2 = 'https://crm.thetechtrial.com/backend/api/inquiry/add';
                axios
                    .post(url2, body1)
                    .then((result) => {
                        // event.target.reset();
                        setUserData({ name: '', email: '', phone: '', message: '' });
                        // toggle();
                        // Swal.fire({ title: 'Thank you', icon: 'success', text: 'Thank you for reaching out to us! Your inquiry has been received. Our team will review your request and get back to you shortly.' })
                        navigate('/thankyou')
                    },
                        (error) => {
                            Swal.fire({ title: 'Oops', icon: 'error', text: 'Something wrong happened please try again later' })
                        }
                    );
        }
        else {
            ReactGA.event({
                category: 'Contact Form',
                action: 'Submit Contact form with failed validation'
            })
        }
    }
    useEffect(() => {
        // Fetch the user's location to set the default country code
        axios.get('https://ipapi.co/json/')
            .then(response => {
                const countryCode = response.data.country_code.toLowerCase();
                setDefaultCountry(countryCode);
            })
            .catch(error => {
                console.error("Error fetching user location: ", error);
            });
    }, []);
    const validateForm = () => {
        const newErrors = {};
        const phoneNumberRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
        if (userData.name.trim() === "") {
            newErrors.name = "Please provide your name";
        }

        // Validate Email
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email)) {
            newErrors.email = "Please Provide valid email address ";
        }

        if (userData.email.trim() === "") {
            newErrors.email = "Please provide email address";
        }
        if (userData.phone.trim() !== '') {
            if (!phoneNumberRegex.test(userData.phone)) {
                newErrors.phone = "Please provide valid phone number";
            }
        }
        // if (userbody.phoneNumber.trim() === "") {
        //     newErrors.mobileNumber = "Phone Number Required";
        // }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }
    return (
        <section className="sec-pad reebga" id="contact">
            <div className="container">
                <div className="row zup">
                    <div className="col-right-a">
                        <div className="sec-heading">
                            <span className="sub-heading mb15">Inquiry</span>
                            <h2>Let’s Get in <span className="ree-text rt40">Touch</span></h2>
                        </div>
                        <div className="home-contact-blocks mt60">
                            <div className="contact-infos">
                                <div className="c-infot"> <span>Mobile Number</span> <a href="tel:+442038850502"><i className="fas fa-phone"></i>+44 20 3885 0502</a> </div>
                                <div className="c-infot"> <span>WhatsApp Number</span> <a href="https://wa.me/917796614664" target="blank" onClick={handleWhatsAppClick}><i className="fab fa-whatsapp"></i> +91 77966 14664</a> </div>
                            </div>
                            <div className="contact-infos mt35">
                                <div className="c-infot"> <span>Business Email</span> <a href="mailto:sales@noorisys.com"><i className="fas fa-envelope"></i> sales@noorisys.com</a> </div>
                                {/* <div className="c-infot"> <span>Connect on Skype</span> <a href="skype:reevan.company"><i className="fab fa-skype"></i> reevan.company</a> </div> */}
                            </div>
                            {/* <div className="our-map mt40">
                                <p className="mb5">Our Location</p>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d113874.29338087929!2d75.72051791246247!3d26.885346595411875!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c4adf4c57e281%3A0xce1c63a0cf22e09!2sJaipur%2C%20Rajasthan!5e0!3m2!1sen!2sin!4v1622665314705!5m2!1sen!2sin" allowfullscreen="" loading="lazy"></iframe>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-right-b">
                        <div className="form-contact-hom">
                            <div className="form-blocks">
                                <form onSubmit={handleSubmit} name="feedback-form">
                                    {!Heading ? <h3>Share your idea or <br />requirement.</h3> : <h3>{Heading}</h3>}
                                    <div className="fieldsets row mt40">
                                        <div className="col-md-6">
                                            <input type="text" placeholder="Full Name" name="name" className="input-ree" value={userData.name} onChange={handleChange} />
                                            {errors.name && (
                                                <span className="error-message pb-4 mb-4" style={{ color: "red" }}>
                                                    {errors.name}
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-6">
                                            <input type="email" placeholder="Email Address" name="email" className="input-ree" value={userData.email} onChange={handleChange} />
                                            {errors.email && (
                                                <span className="error-message mb-4" style={{ color: "red" }}>
                                                    {errors.email}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="fieldsets row">
                                        <div className="col-md-6">
                                            <PhoneInput
                                                country={defaultCountry}
                                                onChange={(value, data) => {
                                                    const dialingCode = data?.dialCode;
                                                    const phoneNo = value.substring(data.dialCode?.length);
                                                    setPhoneNumber({ number: phoneNo, dialingCode: dialingCode })
                                                }}
                                                inputClass='phone-input'
                                                inputStyle={{ background: 'transparent', }}
                                                buttonStyle={{ borderRadius: '6px 0 0 6px' }}
                                                containerClass={`contact-form-phone-container ${isFocused ? 'active' : ''}`}
                                                onFocus={() => setIsFocused(true)}
                                                onBlur={() => setIsFocused(false)}
                                            />
                                            {/* <input type="tel" placeholder="Contact Number" name="phone" className="input-ree" value={userData.phone} onChange={handleChange} /> */}
                                            {errors.phone && (
                                                <span className="error-message mb-4" style={{ color: "red" }}>
                                                    {errors.phone}
                                                </span>
                                            )}
                                        </div>
                                        <div className="col-md-6 m-mt30">
                                            <input type="text" placeholder="Message" name="message" className="input-ree" value={userData.message} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="fieldsets mt20">
                                        <button id='noorisys-quote' type="submit" name="submit" className="ree-btn  ree-btn-grdt1 no-shadows">Send your inquiry <i className="fas fa-arrow-right fa-btn"></i></button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactForm